/**
 * Brand Sticky CTA
 * Shows the floating CTA after the user scrolls past the hero,
 * hides it while #featured-camps is in view, re-shows it below.
 * Bails out if either the hero or the scroll target is missing —
 * the sticky button has nothing to anchor to.
 */
(function () {
  const button = document.querySelector(".rd-brand-sticky-cta");
  if (!button) return;

  const target = document.querySelector(button.dataset.target || "#featured-camps");
  const hero = document.querySelector(".rd-brand-hero");

  if (!hero || !target) {
    button.remove();
    return;
  }

  let heroVisible = true;
  let featuredVisible = false;

  const update = () => {
    button.dataset.visible = (!heroVisible && !featuredVisible) ? "true" : "false";
  };

  new IntersectionObserver((entries) => {
    heroVisible = entries[0].isIntersecting;
    update();
  }, { threshold: 0 }).observe(hero);

  new IntersectionObserver((entries) => {
    featuredVisible = entries[0].isIntersecting;
    update();
  }, { threshold: 0 }).observe(target);

  // iOS Safari: when the dynamic toolbar hides, `position:fixed; bottom:0`
  // can stay anchored to the layout viewport, leaving empty space below
  // the button. Sync `bottom` to the visual viewport so the button always
  // sits at the actual visible bottom.
  const vv = window.visualViewport;
  if (vv) {
    const syncBottom = () => {
      const offset = window.innerHeight - vv.height - vv.offsetTop;
      button.style.setProperty("--sticky-bottom", Math.max(0, offset) + "px");
    };
    vv.addEventListener("resize", syncBottom);
    vv.addEventListener("scroll", syncBottom);
    syncBottom();
  }

  button.addEventListener("click", (e) => {
    e.preventDefault();
    target.scrollIntoView({ behavior: "smooth" });
  });
})();
